<div class="titan-menu-trigger">
  <div class="trigger-button" (click)="toggle()">
    <ng-content select=":not(app-titan-menu-popover)"></ng-content>
  </div>
  <ng-content select="app-titan-menu-popover"></ng-content>
</div>
